import { render } from "./ComprobanteS.vue?vue&type=template&id=745e853c&scoped=true"
import script from "./ComprobanteS.vue?vue&type=script&lang=js"
export * from "./ComprobanteS.vue?vue&type=script&lang=js"

import "./ComprobanteS.vue?vue&type=style&index=0&id=745e853c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745e853c"]])

export default __exports__